<template>
    <h1>这是测试</h1>
</template>

<script>
export default {
    mounted () {
        let secondNavItem = [
            { path: 'overView', msg: '总览' },
            true,
            { path: 'echarts', msg: '详细分析' }
        ]
        this.$store.state.secondNavItem = secondNavItem
        this.$store.state.isFlagLiClass = 'overView'
        this.getData()
    },
    methods: {
        getData () {
            if (this.$route.query.appId) {
                this.appId = this.$route.query.appId
                this.$store.state.appId = this.appId
            } else {
                this.appId = this.$store.state.appId
            }
            const path = `/developer/${
                this.appId
            }/downloadLine/report`
            this._api
                .request('get', path)
                .then(res => {
                })
                .catch(error => {
                    console.log(error)
                })
        }
    }
}
</script>
